export default __webpack_public_path__ + "static/media/maaz.cd5bf9de.jpg";